<template>
  <v-card elevation="1" class="mb-4">
    <v-card-text>
      <h6 class="text-h6 black--text">Retenciones</h6>
      <p class="text-body-2 mb-0">Ingrese las retenciones emitidas</p>
      <v-row class="mt-0">
        <v-col md="12" v-if="!isViewModal && !openFromPaymentOrder">
          <v-tooltip bottom v-if="!isViewModal && !loading_calc_retenciones && !openFromPaymentOrder">
            <template v-slot:activator="{ on }">
              <span v-on="on">
                <v-btn small color="blue-grey" class="text-white" @click="addTributeDetail()" :disabled="!(item && item.receiver && item.receiver.id > 0)">
                  <v-icon big color="green"> add </v-icon>
                  <span>Agregar item</span>
                </v-btn>
              </span>
            </template>
            <span>Seleccione un receptor para agregar retenciones</span>
          </v-tooltip>
        </v-col>
        <v-col md="12">
          <v-data-table :loading="loading_calc_retenciones" class="pb-4" :headers="header_tribute" :items="item.tributes" style="border: solid 1px #1c1c1c" :hide-default-footer="true" :items-per-page="100">
            <template v-slot:item="props">
              <tr>
                <td style="min-width: 25%">
                  <v-combobox
                    v-model="props.item.tribute"
                    :disabled="isViewModal || loading_calc_retenciones || openFromPaymentOrder"
                    data-vv-as="tribute"
                    :name="'tribute_' + props.index"
                    item-text="name"
                    :items="tributes"
                    label="Tipo*"
                    autocomplete="off"
                    :loading="loading"
                    v-validate="'required|combobox_required'"
                    @change="calcRetenciones(props.index)"                    
                    return-object
                  ></v-combobox>                  
                  <span class="red--text">{{ errors.first('tribute_' + props.index) }}</span>
                </td>
                <td style="min-width: 35%">
                  <v-text-field autocomplete="off" :disabled="isViewModal || loading_calc_retenciones || openFromPaymentOrder" :name="'descripcion_' + props.index" placeholder="Descripción" dense type="text" v-model="props.item.description" class="mt-3" />
                  <span class="red--text">{{ errors.first('descripcion_' + props.index) }}</span>
                </td>
                <td style="max-width: 50px">
                  <v-text-field autocomplete="off" :disabled="isViewModal || loading_calc_retenciones || openFromPaymentOrder" :name="'alicuota_' + props.index" placeholder="Alicuota" dense type="number" step="0.01" v-model="props.item.alicuota" @input="recalcImporte(props.index)" class="mt-3"/>
                  <span class="red--text">{{ errors.first('alicuota_' + props.index) }}</span>
                </td>
                <td>
                  <v-text-field autocomplete="off" :disabled="isViewModal || loading_calc_retenciones || openFromPaymentOrder" :name="'importe_sobre_el_cual_calcular_' + props.index" placeholder="Base de cálculo" step="0.01" dense type="number" v-model="props.item.importe_sobre_el_cual_calcular" @input="recalcImporte(props.index)" class="mt-3" />
                  <span class="red--text">{{ errors.first('importe_sobre_el_cual_calcular_' + props.index) }}</span>
                </td>
                <td>
                  <v-text-field autocomplete="off" readonly disabled :name="'amount_' + props.index" placeholder="Importe*" dense v-validate="'decimal'" type="number" v-model="props.item.amount" class="mt-3" />
                  <span class="red--text">{{ errors.first('amount_' + props.index) }}</span>
                </td>
                <td class="text-center">
                  <v-tooltip bottom v-if="!isViewModal && !loading_calc_retenciones && !openFromPaymentOrder">
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on" small color="red" @click="removeDetail(props.item, 'tribute')"> indeterminate_check_box </v-icon>
                    </template>
                    <span>Remover</span>
                  </v-tooltip>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-col>
        <v-col md="12">
          <v-chip class="float-right" outlined color="primary">Total retenciones: {{ formatUtils.formatPrice(total_retenciones) }} </v-chip>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
import { impuestosService } from "@/libs/ws/impuestosService";
import { formatUtils } from "@/libs/utils/formatUtils";
import paymentMethod from "@/constants/paymentMethod.js";

export default {
  created() {
    this.$validator = this.validator;
  },
  components: {},
  props: { loading_calc_retenciones: Boolean, setLoadingCalcRetenciones: Function, item: Object, isViewModal: Boolean, validator: Object, receiver: { type: Object, default: null }, openFromPaymentOrder: Boolean },
  computed: {
    receiverMissing() {
      console.log("receiverMissing computed", (!this.item || !this.item.receiver || !(this.item.receiver.id > 0)));
      return (!this.item || !this.item.receiver || !(this.item.receiver.id > 0));
    },
  },
  data: () => ({
    header_tribute: [
      { text: "Tributo", value: "product", sortable: false },
      { text: "Descripción", value: "description", sortable: false },
      { text: "Alicuota(%)", value: "alicuota", sortable: false },
      { text: "Base de calculo", value: "importe_sobre_el_cual_calcular", sortable: false, class: "bg-grey" },
      { text: "Importe Retencion", value: "amount", sortable: false },
      { text: "", value: "", sortable: false, class: "bg-grey" },
    ],
    tributes: [],
    total_retenciones: 0,
    loading: false,    
    formatUtils: formatUtils,
  }),
  watch: {
    item: {
      handler: function (newValue) {
        this.getTotal();
      },
      deep: true,
    },
    "receiver.id": {
      handler: function () {
        this.getTributos();
      },
    },
    "item.supplier": {
      handler: function () {
        this.getTributos();
      },
    },
    "item.receiver": {
      handler: function () {
        this.getTributos();
      },
    },
    "item.spents": {
      handler: function () {
        this.calcRetenciones();
      },
      deep: true,
    },
    "item.spent_payment_methods": {
      handler: function () {
        if (this.isViewModal) return;
        if (this.hayPagoConCheque()) {
          this.calcRetenciones();
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.getTributos();
  },
  methods: {
    getTotal() {
      let total = 0;
      if (!this.item.tributes) return;

      this.item.tributes.forEach((tribute) => {
        const amount = tribute.amount != undefined ? tribute.amount : 0;
        total += parseFloat(amount);
      });

      this.total_retenciones = total;
    },
    addTributeDetail() {
      this.item.tributes.push({
        description: "",
        nro_cert: null,
        amount: null,
        tribute: null,
      });
    },
    getTributos(){
      // En modo view o desde payment order, no refetch tributes ya que vienen del backend
      if(this.isViewModal || this.openFromPaymentOrder){
         return;
      }

      const params = { categoria_impuesto: impuestosService.RETENCION };
      if (this.item && this.item.supplier && this.item.supplier.id) {
        params.supplier = { id: this.item.supplier.id };
      }
      if (this.item.receiver && this.item.receiver.id) {
        params.emitter = { id: this.item.receiver.id };
      }
      if(
        params.emitter == null || params.supplier == null ||
        params.emitter == undefined || params.supplier == undefined     
      ){        
        this.tributes = [];        
        console.log("No se tienen los datos necesarios para consultar las retenciones. Se deben ingresar el receptor y el proveedor para poder consultar las retenciones correspondientes",params);
        return;
      }

      this.loading = true;

      impuestosService
        .filter(params)
        .then((response) => {
          if (response.status) {
            this.tributes = response.result;
            console.log("tributes", this.tributes);            
            this.item.tributes = [];          
            this.calcRetenciones();
          }
        })
        .catch((e) => {
          console.log("impuestosService.filter error");
          console.log(e);
          this.$toast.error(e.msg);
        })
        .finally(() => (this.loading = false));
    },
    hayPagoConCheque() {
      return (this.item.spent_payment_methods || []).some(
        (pm) => pm.payment_method && pm.payment_method.id == paymentMethod.cheque
      );
    },
    getTotalRetencionesActuales() {
      return (this.item.tributes || []).reduce(
        (acc, t) => acc + parseFloat(t.amount || 0), 0
      );
    },
    getSumaMediosNoCheque() {
      return (this.item.spent_payment_methods || [])
        .filter((pm) => !(pm.payment_method && pm.payment_method.id == paymentMethod.cheque))
        .reduce((acc, pm) => acc + parseFloat(pm.amount || 0), 0);
    },
    // Monto de retención a restar de la base del pago a cuenta:
    // solo la parte NO cubierta por los medios no-cheque, y solo si hay cheque.
    getMontoRetencionARestarDePagoACuenta() {
      if (!this.hayPagoConCheque()) return 0;
      const restante = this.getTotalRetencionesActuales() - this.getSumaMediosNoCheque();
      return Math.max(0, restante);
    },
    getRentecionCalcParams(){
      const params = {
        cbte_fch: this.item.cbte_fch,      
        emitter: null,
        supplier: null,
        
        imp_total: 0,
        imp_iva: 0,
        imp_neto: 0,
        imp_op_ex: 0,
        imp_tributo: 0,

        detalles: []//id, cbte_tipo, provincia, imp_total, imp_iva, imp_neto, imp_op_ex, imp_tributo
      };
      
      let provincia_emitter_id = null;
      let provincia_supplier_id = null;
      if (this.item && this.item.supplier && this.item.supplier.id) {
        params.supplier = { id: this.item.supplier.id };        
        provincia_supplier_id = this.item.supplier.provincia ? this.item.supplier.provincia.id : null;
      }
      if (this.item.receiver && this.item.receiver.id) {
        params.emitter = { id: this.item.receiver.id };
        provincia_emitter_id = this.item.receiver.provincia ? this.item.receiver.provincia.id : null;
      }

      //Tengo que recorrer todos los items de item.spents y:
      //1- sumar los totales
      //2- separar los detalles segun cbte_tipo y provincia

      
      //agregar importes segun item.spents
      let imp_total = 0, imp_iva = 0, imp_neto = 0, imp_op_ex = 0, imp_tributo = 0;
      let retencionesYaRestadas = false;
      if (this.item.spents && this.item.spents.length > 0) {
        this.item.spents.forEach((spent) => { 
          console.log("calculando importes para retenciones, spent", spent.imp_total,spent); 
          
          //Lo que se va a pagar es 'spent.imp_total'
          let porcentaje_a_imputar = spent.imp_total / spent.spent.imp_total;

          imp_total += spent.spent.imp_total != undefined ? parseFloat(spent.spent.imp_total) * porcentaje_a_imputar : 0;
          imp_iva += spent.spent.imp_iva != undefined ? parseFloat(spent.spent.imp_iva) * porcentaje_a_imputar : 0;
          imp_neto += spent.spent.imp_neto != undefined ? parseFloat(spent.spent.imp_neto) * porcentaje_a_imputar : 0;
          imp_op_ex += spent.spent.imp_op_ex != undefined ? parseFloat(spent.spent.imp_op_ex) * porcentaje_a_imputar : 0;
          imp_tributo += spent.spent.imp_trib != undefined ? parseFloat(spent.spent.imp_trib) * porcentaje_a_imputar : 0;  
          
          
          if(spent.spent.spent_number_label == "Pago a cuenta"){//PAGO A CUENTA
              let base_pago_a_cuenta = parseFloat(spent.imp_total);
              //Restar solo la retencion no cubierta por medios no-cheque (aplica una unica vez)
              if(!retencionesYaRestadas){
                const restar = this.getMontoRetencionARestarDePagoACuenta();
                if(restar > 0){
                  base_pago_a_cuenta = Math.max(0, base_pago_a_cuenta - restar);
                  retencionesYaRestadas = true;
                }
              }
              imp_neto += base_pago_a_cuenta;
              imp_total += base_pago_a_cuenta;
              params.detalles.push({
                id: 1,//Factura A para que aplique retencion
                cbte_tipo: null,
                imp_total: base_pago_a_cuenta,
                imp_iva: 0,
                imp_neto: base_pago_a_cuenta,
                imp_op_ex: 0,
                imp_tributo: 0,
                provincia: provincia_supplier_id ? provincia_supplier_id : (provincia_emitter_id ? provincia_emitter_id : null)
              });
          }else{
              params.detalles.push({
                id: spent.spent.id,
                cbte_tipo: spent.spent.cbte_tipo?.Id,
                imp_total: spent.spent.imp_total != undefined ? parseFloat(spent.spent.imp_total) * porcentaje_a_imputar : 0,
                imp_iva: spent.spent.imp_iva != undefined ? parseFloat(spent.spent.imp_iva) * porcentaje_a_imputar : 0,
                imp_neto: spent.spent.imp_neto != undefined ? parseFloat(spent.spent.imp_neto) * porcentaje_a_imputar : 0,
                imp_op_ex: spent.spent.imp_op_ex != undefined ? parseFloat(spent.spent.imp_op_ex) * porcentaje_a_imputar : 0,
                imp_tributo: spent.spent.imp_trib != undefined ? parseFloat(spent.spent.imp_trib) * porcentaje_a_imputar : 0,  
                provincia: provincia_supplier_id ? provincia_supplier_id : (provincia_emitter_id ? provincia_emitter_id : null)
              });
          }
          
        });
      }
      
      params.imp_total = imp_total;
      params.imp_iva = imp_iva;
      params.imp_neto = imp_neto;
      params.imp_op_ex = imp_op_ex;
      params.imp_tributo = imp_tributo;      

      if(
        params.emitter == null || params.supplier == null ||
        params.emitter == undefined || params.supplier == undefined ||
        !(params.imp_total > 0 || params.imp_iva > 0 || params.imp_neto > 0 || params.imp_op_ex > 0 || params.imp_tributo > 0)
      ){
        console.log("No se tienen los datos necesarios para consultar las retenciones. Se deben ingresar el receptor, el proveedor y los importes de la factura para poder consultar las retenciones correspondientes");
        console.log("params", params);
        this.tributes = [];
        return null;
      }
      console.log("Consultando retenciones con params", params);

      return params;
    },
    calcRetenciones(item_tributes_index = null) {
      if(this.isViewModal){
        return;
      }

      const params = this.getRentecionCalcParams();
      if(params == null){
        return;
      }

      if(item_tributes_index != null){
        params.impuesto_id = this.item.tributes[item_tributes_index].tribute.id;
      }
      
      //this.loading_calc_retenciones = true;
      this.$emit("setLoadingCalcRetenciones", true);
      impuestosService
        .getRetencionesForPayment(params)
        .then((response) => {
          if (response.status) {            

            //Hay que agregar las filas automaticamente y preseleccionar el tributo
            if (response.result.length > 0) {
              if(item_tributes_index != null){
                const retencion = response.result[0]; 
                console.log("before", item_tributes_index);
                console.log("this.item.tributes", this.item.tributes[item_tributes_index].tribute);         
                          
                this.$set(this.item.tributes, item_tributes_index, {
                  auto: this.item.tributes[item_tributes_index].auto,
                  description: retencion.description,                  
                  amount: retencion.amount,
                  tribute: retencion.impuesto,
                  alicuota: retencion.alicuota,
                  importe_sobre_el_cual_calcular: retencion.importe_sobre_el_cual_calcular,
                  importe_accumulado: retencion.importe_accumulado,
                  retenciones_accumuladas: retencion.retenciones_accumuladas,
                  padron_alicuota: retencion.padron_alicuota,
                  escala_aplicable_desde_monto: retencion.escala_aplicable_desde_monto,
                  escala_aplicable_hasta_monto: retencion.escala_aplicable_hasta_monto,
                  escala_aplicable_alicuota_excedente: retencion.escala_aplicable_alicuota_excedente,
                  escala_aplicable_monto_base: retencion.escalable_aplicable_monto_base,                  
                });
              }else{
                this.item.tributes = [];
                response.result.forEach((retencion) => {
                  this.item.tributes.push({
                    auto: true,
                    description: retencion.description,                  
                    amount: retencion.amount,
                    tribute: retencion.impuesto,
                    alicuota: retencion.alicuota,
                    importe_sobre_el_cual_calcular: retencion.importe_sobre_el_cual_calcular,
                    importe_accumulado: retencion.importe_accumulado,
                    retenciones_accumuladas: retencion.retenciones_accumuladas,
                    padron_alicuota: retencion.padron_alicuota,
                    escala_aplicable_desde_monto: retencion.escala_aplicable_desde_monto,
                    escala_aplicable_hasta_monto: retencion.escala_aplicable_hasta_monto,
                    escala_aplicable_alicuota_excedente: retencion.escala_aplicable_alicuota_excedente,
                    escala_aplicable_monto_base: retencion.escalable_aplicable_monto_base,                  
                  });                                  
                });
              }
            }
          }
        })
        .catch((e) => {
          console.log("impuestosService.getForPayment error");
          console.log(e);
          this.$toast.error(e.msg);
        })
        .finally(() => this.$emit("setLoadingCalcRetenciones", false));
    },
    recalcImporte(index) {
      const t = this.item.tributes[index];
      const alicuota = parseFloat(t.alicuota) || 0;
      const base = parseFloat(t.importe_sobre_el_cual_calcular) || 0;
      this.$set(t, "amount", formatUtils.formatPriceNumber((base * alicuota) / 100));
    },
    removeDetail(item, colection_name) {
      if (colection_name == "tribute") {
        const index_item = this.item.tributes.indexOf(item);
        if (index_item > -1) this.item.tributes.splice(index_item, 1);
      }
    },
    
  },
};
</script>
